import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-body-2 font-weight-medium mr-3" }
const _hoisted_2 = { class: "text-caption text-medium-emphasis" }
const _hoisted_3 = { class: "text-caption text-medium-emphasis" }
const _hoisted_4 = { class: "d-flex align-center" }

import { ref, computed, onMounted } from 'vue'
import axios from '@/plugins/axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChunksPanel',
  setup(__props) {

const API_BASE = process.env.VUE_APP_API_BASE_URL as string

const headers = [
  { title: 'ID',     key: 'id',             width: '60px' },
  { title: 'Tür',    key: 'index_type',      width: '80px' },
  { title: 'Dosya',  key: 'dosya_adi',       width: '150px' },
  { title: 'Yasa No',key: 'yasa_no',         width: '100px' },
  { title: 'Madde',  key: 'madde_no',        width: '70px' },
  { title: 'Başlık', key: 'baslik',          width: '180px' },
  { title: 'İçerik', key: 'icerik_preview',  sortable: false },
  { title: '',       key: 'actions',         sortable: false, width: '80px' },
]

const typeItems = [
  { title: 'Yasa / Tüzük', value: 'laws' },
  { title: 'Mahkeme Kararı', value: 'cases' },
]

const perPageOptions = [10, 20, 50, 100, 200]

const filters   = ref({ type: '', yasa_no: '', mahkeme: '', q: '' })
const mahkemeler = ref<string[]>([])
const items     = ref<any[]>([])
const total     = ref(0)
const page      = ref(1)
const limit     = ref(20)
const loading   = ref(false)
const error     = ref<string | null>(null)
const selected  = ref<number[]>([])

const totalPages = computed(() => Math.ceil(total.value / limit.value) || 1)

const editDialog   = ref(false)
const editItem     = ref<any>(null)
const saving       = ref(false)

const deleteDialog  = ref(false)
const deleteTarget  = ref<any>(null)
const deleting      = ref(false)

const bulkDeleteDialog = ref(false)
const bulkDeleting     = ref(false)

async function load() {
  loading.value = true
  error.value   = null
  try {
    const params: any = { page: page.value, limit: limit.value }
    if (filters.value.type)    params.type    = filters.value.type
    if (filters.value.yasa_no) params.yasa_no = filters.value.yasa_no
    if (filters.value.mahkeme) params.mahkeme = filters.value.mahkeme
    if (filters.value.q)       params.q       = filters.value.q

    const res = await axios.get(`${API_BASE}/admin/parser/chunks`, { params })
    items.value    = res.data.items
    total.value    = res.data.total
    selected.value = []
  } catch (e: any) {
    error.value = e?.response?.data?.error ?? e?.message ?? 'Hata'
  } finally {
    loading.value = false
  }
}

function resetAndLoad() {
  page.value = 1
  load()
}

async function loadMahkemeler() {
  try {
    const res = await axios.get(`${API_BASE}/admin/parser/mahkemeler`)
    mahkemeler.value = res.data.mahkemeler
  } catch { /* ignore */ }
}

function openEdit(item: any) {
  editItem.value = { ...item }
  editDialog.value = true
}

async function saveEdit() {
  saving.value = true
  try {
    await axios.patch(`${API_BASE}/admin/parser/chunks/${editItem.value.id}`, {
      baslik: editItem.value.baslik,
      icerik: editItem.value.icerik,
    })
    editDialog.value = false
    load()
  } catch (e: any) {
    error.value = e?.response?.data?.error ?? e?.message ?? 'Kaydetme hatası'
  } finally {
    saving.value = false
  }
}

function confirmDelete(item: any) {
  deleteTarget.value = item
  deleteDialog.value = true
}

async function doDelete() {
  deleting.value = true
  try {
    await axios.delete(`${API_BASE}/admin/parser/chunks/${deleteTarget.value.id}`)
    deleteDialog.value = false
    load()
  } catch (e: any) {
    error.value = e?.response?.data?.error ?? e?.message ?? 'Silme hatası'
  } finally {
    deleting.value = false
  }
}

function confirmBulkDelete() {
  bulkDeleteDialog.value = true
}

async function doBulkDelete() {
  bulkDeleting.value = true
  try {
    await axios.delete(`${API_BASE}/admin/parser/chunks/bulk`, {
      data: { ids: selected.value },
    })
    bulkDeleteDialog.value = false
    load()
  } catch (e: any) {
    error.value = e?.response?.data?.error ?? e?.message ?? 'Toplu silme hatası'
  } finally {
    bulkDeleting.value = false
  }
}

onMounted(() => {
  load()
  loadMahkemeler()
})

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, {
      class: "mb-3",
      dense: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: filters.value.type,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((filters.value.type) = $event)),
                resetAndLoad
              ],
              items: typeItems,
              label: "Tür",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: filters.value.yasa_no,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.yasa_no) = $event)),
              label: "Yasa No",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              clearable: "",
              onKeyup: _withKeys(resetAndLoad, ["enter"]),
              "onClick:clear": resetAndLoad
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              modelValue: filters.value.mahkeme,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((filters.value.mahkeme) = $event)),
                resetAndLoad
              ],
              items: mahkemeler.value,
              label: "Mahkeme",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              clearable: ""
            }, null, 8, ["modelValue", "items"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          sm: "3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: filters.value.q,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.value.q) = $event)),
              label: "Arama",
              density: "compact",
              variant: "outlined",
              "hide-details": "",
              clearable: "",
              "prepend-inner-icon": "mdi-magnify",
              onKeyup: _withKeys(resetAndLoad, ["enter"]),
              "onClick:clear": resetAndLoad
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (error.value)
      ? (_openBlock(), _createBlock(_component_v_alert, {
          key: 0,
          type: "error",
          class: "mb-3",
          closable: "",
          "onClick:close": _cache[4] || (_cache[4] = ($event: any) => (error.value = null))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(error.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (selected.value.length)
      ? (_openBlock(), _createBlock(_component_v_card, {
          key: 1,
          class: "mb-2 pa-2 d-flex align-center",
          color: "primary",
          variant: "tonal"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, _toDisplayString(selected.value.length) + " chunk seçildi", 1),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              size: "small",
              variant: "text",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (selected.value = []))
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("Seçimi Temizle", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              size: "small",
              color: "error",
              variant: "flat",
              class: "ml-2",
              onClick: confirmBulkDelete
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createElementVNode("span", {
                  class: "material-symbols-outlined mr-1",
                  style: {"font-size":"16px"}
                }, "delete", -1),
                _createTextVNode(" Seçilenleri Sil ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_data_table, {
          modelValue: selected.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selected).value = $event)),
          headers: headers,
          items: items.value,
          loading: loading.value,
          "items-per-page": limit.value,
          "item-value": "id",
          "show-select": "",
          "hide-default-footer": "",
          density: "compact"
        }, {
          "item.index_type": _withCtx(({ item }) => [
            _createVNode(_component_v_chip, {
              size: "x-small",
              color: item.index_type === 'laws' ? 'success' : 'info',
              variant: "flat"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.index_type === 'laws' ? 'Yasa' : 'Karar'), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]),
          "item.icerik_preview": _withCtx(({ item }) => [
            _createElementVNode("span", _hoisted_2, _toDisplayString(item.icerik_preview), 1)
          ]),
          "item.actions": _withCtx(({ item }) => [
            _createVNode(_component_v_btn, {
              size: "x-small",
              icon: "",
              variant: "plain",
              onClick: ($event: any) => (openEdit(item))
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createElementVNode("span", {
                  class: "material-symbols-outlined",
                  style: {"font-size":"16px"}
                }, "edit", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_btn, {
              size: "x-small",
              icon: "",
              variant: "plain",
              color: "error",
              onClick: ($event: any) => (confirmDelete(item))
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createElementVNode("span", {
                  class: "material-symbols-outlined",
                  style: {"font-size":"16px"}
                }, "delete", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "items", "loading", "items-per-page"]),
        _createVNode(_component_v_card_text, { class: "d-flex align-center flex-wrap gap-2 pt-2" }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, "Toplam: " + _toDisplayString(total.value.toLocaleString()), 1),
            _createVNode(_component_v_spacer),
            _createElementVNode("div", _hoisted_4, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-caption text-medium-emphasis mr-2" }, "Sayfa başı:", -1)),
              _createVNode(_component_v_select, {
                modelValue: limit.value,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((limit).value = $event)),
                  resetAndLoad
                ],
                items: perPageOptions,
                density: "compact",
                variant: "outlined",
                "hide-details": "",
                style: {"width":"80px"}
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_v_pagination, {
              modelValue: page.value,
              "onUpdate:modelValue": [
                _cache[8] || (_cache[8] = ($event: any) => ((page).value = $event)),
                load
              ],
              length: totalPages.value,
              "total-visible": 5,
              density: "compact"
            }, null, 8, ["modelValue", "length"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: editDialog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((editDialog).value = $event)),
      "max-width": "700"
    }, {
      default: _withCtx(() => [
        (editItem.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Chunk Düzenle — #" + _toDisplayString(editItem.value.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_text_field, {
                      modelValue: editItem.value.baslik,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((editItem.value.baslik) = $event)),
                      label: "Başlık",
                      variant: "outlined",
                      density: "compact",
                      class: "mb-2"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: editItem.value.icerik,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((editItem.value.icerik) = $event)),
                      label: "İçerik",
                      variant: "outlined",
                      rows: "8",
                      "auto-grow": ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (editDialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createTextVNode("İptal", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      loading: saving.value,
                      onClick: saveEdit
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("Kaydet", -1)
                      ]))]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: deleteDialog.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((deleteDialog).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createTextVNode("Chunk Sil", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, "#" + _toDisplayString(deleteTarget.value?.id), 1),
                _cache[25] || (_cache[25] = _createTextVNode(" numaralı chunk silinecek. Bu işlem geri alınamaz. ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (deleteDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("İptal", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  loading: deleting.value,
                  onClick: doDelete
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode("Sil", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: bulkDeleteDialog.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((bulkDeleteDialog).value = $event)),
      "max-width": "440"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("Toplu Silme", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, _toDisplayString(selected.value.length), 1),
                _cache[29] || (_cache[29] = _createTextVNode(" chunk kalıcı olarak silinecek. Bu işlem geri alınamaz. ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (bulkDeleteDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode("İptal", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  loading: bulkDeleting.value,
                  onClick: doBulkDelete
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode("Sil", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})